<template>
  <div id="app">
    <div class="t3d"></div>
    <router-view />
  </div>
</template>

<script>

export default {
  beforeCreate() {

  },
  created() {
  }
};
</script>

<style>
@import '//at.alicdn.com/t/font_2858234_t3ud4itjc6m.css';

.t3d {
  display: none;
  transform: translate3d(0, 0, 0);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.popper-color-prop,.el-select-dropdown,.el-dropdown-menu{
  z-index: 99999!important;
}

</style>
